/**
 * Support contact helper.
 *
 * Opens the user's email client with a pre-addressed support message.
 * The destination address is INTENTIONALLY kept out of the visible UI —
 * it lives only in this module and is injected into a `mailto:` URL at
 * click time. Do NOT render SUPPORT_EMAIL anywhere on the page.
 */

// Hidden from UI on purpose. Reference only via openSupportEmail().
const SUPPORT_EMAIL = 'marionmoyn@kinscircleapp.com';

export const SUPPORT_SUBJECT = 'KinsCircle Support Request';
export const SUPPORT_BODY_PLACEHOLDER =
  'Hi KinsCircle Support, I need help with…';

/**
 * Open the user's default mail app with a pre-filled support message.
 * The recipient address is never exposed to the DOM.
 */
export function openSupportEmail(opts?: { subject?: string; body?: string }): void {
  const subject = encodeURIComponent(opts?.subject ?? SUPPORT_SUBJECT);
  const body = encodeURIComponent(opts?.body ?? SUPPORT_BODY_PLACEHOLDER);
  const href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

  // Use location assignment so the browser hands off to the OS mail client
  // without leaving a visible link in the DOM.
  if (typeof window !== 'undefined') {
    window.location.href = href;
  }
}
